module.exports = __webpack_public_path__ + "assets/images/icons/blue/icon_check-green.svg?v=bf5585a7";